import FuseScrollbars from '@fuse/core/FuseScrollbars';
import {makeStyles} from '@material-ui/core/styles';
import Logo from 'app/layouts/shared-components/Logo';
import Navigation from 'app/layouts/shared-components/Navigation';
import clsx from 'clsx';
import {memo, useState} from 'react';
import Hidden from '@material-ui/core/Hidden';
import {useSelector} from 'react-redux';
import AdjustFontSize from '../../shared-components/AdjustFontSize';
import UserMenu from '../../shared-components/UserMenu';
import NavbarToggleButton from '../../shared-components/NavbarToggleButton';
import OnlineIndicator from 'app/main/shared-components/online-indicator/OnlineIndicator';

const useStyles = makeStyles(theme => ({
	root: {
		backgroundColor: '#36465a',
		color: theme.palette.text.primary
	}
}));

function NavbarLayout2(props) {
	const {appBarModuleTitle} = useSelector(({schedulerCommon}) => schedulerCommon.schedulerCommon);
	const classes = useStyles(props);
	const [openModal, setOpenModal] = useState(false);

	return (
		<div className={clsx('w-full shadow-md', classes.root, props.className)}>
			<div
				className={clsx(
					'flex flex-auto justify-between items-center w-full h-full container p-0 lg:px-24 z-20'
				)}
			>
				<Hidden lgUp>
					<div className="flex flex-row items-center">
						<NavbarToggleButton className="w-40 h-40 p-0 mx-0 sm:mx-8" />
						<span className="font-bold text-16">{appBarModuleTitle}</span>
					</div>
				</Hidden>
				<Hidden mdDown>
					<div className="flex w-9/12 flex-shrink-0 items-center px-8">
						<div className="flex w-2/12 mr-40">
							<Logo />
						</div>
						<div className="flex w-10/12">
							{/* Disabling horizontal scroll to prevent a navbar scrollbar with three or fewer options (for technicians)*/}
							<FuseScrollbars className="flex h-full items-center" option={{suppressScrollX: true}}>
								<Navigation className="w-full" layout="horizontal" />
							</FuseScrollbars>
						</div>
					</div>
				</Hidden>

				<div className="flex w-3/12 flex-shrink-0 items-center px-8 justify-end">
					<OnlineIndicator />
					<AdjustFontSize />
					<UserMenu />
				</div>
			</div>
		</div>
	);
}

export default memo(NavbarLayout2);
